export default {
  storeTo: 'Magazzino verso',
  weightHaveUnit: 'Peso (g)',
  productType: 'Tipo di prodotto',
  long: 'Lunghezza (cm)',
  width: 'Larghezza (cm)',
  height: 'Altezza (cm)',
  seeDetail: 'Vedi dettagli',
  queryTips: 'Inserisci i parametri corrispondenti per verificare il trasporto!',
  carrier: 'Corriere',
  carrierCode: 'Codice corriere',
  product: 'Prodotto',
  productCode: 'Codice prodotto',
  totalfee: 'Costo totale',
  billingWeight: 'Peso tassabile',
  feeEstimation: 'Stima costi',
  postFeeEstimation: 'Stima spedizione',
  postFee: 'Costo di spedizione',
  postTime: 'Tempo di consegna stimato',
  packUp: 'Riduci',
  startWeight: 'Peso iniziale',
  endWeight: 'Peso finale',
  calcExpression: 'Espressione di calcolo',
  baseFreight: 'Nolo base',
  registrationFee: 'Costo di registrazione',
  noSend: 'Prodotti non disponibili',
  canSend: 'Prodotti disponibili',
  priceFrom: 'Composizione del costo',
  itemLimit: 'Limite articoli',
  disReason: 'Motivo di indisponibilità',
  BasicFreight: 'Nolo base',
  OperationFreight: 'Costi doganali e di dichiarazione',
  RegistrationFreight: 'Costo di registrazione',
  IossFee: 'Costo IOSS',
  TariffFreight: 'Dazi doganali',
  VATFregith: 'Imposta sul Valore Aggiunto (IVA)',
  AserviceFee: 'Costi di servizio aggiuntivi',
  ExtraSizeFreight: 'Supplemento per dimensioni fuori standard',
  AdditionalDeliveryFeeForFemoteAreas: 'Costo di consegna aggiuntivo per aree remote',
  FuelSurcharge: 'Supplemento carburante',
  zoneCode: 'Zona',
  amount: 'Prezzo',
  rate: 'Tasso',
  conditionExpression: 'Calcolo',
  feeFactor: 'Fattore di costo',
  continuedPrice: 'Costo del peso aggiuntivo',
  continuedWeight: 'Peso aggiuntivo (g)',
  firstPrice: 'Costo del primo peso',
  firstWeight: 'Primo peso (g)',
  weightRangeStart: 'Peso iniziale (g)',
  weightRangeEnd: 'Peso finale (g)',
  holder: {
    toCountry: 'Scegli la destinazione',
    inputWeight: 'Inserisci il peso',
    selectCountry: 'Seleziona un paese',
    selectCarrier: 'Seleziona un corriere/linea di trasporto/paese di destinazione',
    selectCategory: 'Scegli la restrizione di spedizione',
  },
  typeDelivery: 'Tipi di consegna',
  shippingTime: 'Tempo di consegna stimato',
  workDay: 'giorni lavorativi',
  deliveryTips: 'Consigli sulla consegna',
  estimatedShippingFee: 'Costo di spedizione stimato',
  lineServiceTips:
    'Nota: Tutti i servizi logistici per le rotte non gestite direttamente da acbuy sono forniti da fornitori di servizi logistici terzi, che adegueranno i prezzi di trasporto in base alle condizioni di mercato. In caso di variazioni di prezzo, acbuy ti informerà in anticipo. In caso di problemi con i servizi logistici, acbuy può comunicare con il fornitore di servizi logistici terzo per tuo conto.',
  logisticsStatement: '<Dichiarazione sul servizio logistico>',
  customizedDelivery: 'Servizio di consegna personalizzato',
  customizedDeliveryText:
    'Consegna di merci alla rinfusa, trasporto marittimo e ferroviario, puoi scegliere un servizio di consegna personalizzato',
  customizeNow: 'Personalizza ora',
  declareAmountRange: "Intervallo dell'importo della dichiarazione",
  viewUnavailableLines: 'Visualizza linee non disponibili (non disponibili:',
  'i18n-0000001': 'Tasso di consegna',
  'i18n-0000002':
    'Per tutti i pacchi spediti tra il {startTime} e il {endTime}, la percentuale di pacchi che sono stati consegnati fino ad oggi',
  'i18n-0000003': 'giorni',
  couponDiscount: 'Sconto del coupon',
  expectedDiscount: 'Sconto previsto',
}
